export const vkPushEvent = (goal, id = 3117532) => {
  if (typeof window === 'undefined') return;
  const _tmr = window._tmr || (window._tmr = []);
  _tmr.push({ type: 'reachGoal', id, goal });
};
